import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Sun, Moon, CheckSquare, Utensils, Activity, Wind, Pill, Calendar } from 'lucide-react';
export function WhatIsIncluded() {
  const features = [{
    icon: BookOpen,
    text: 'Ebook PDF “Biohacking Exprés”'
  }, {
    icon: Sun,
    text: 'Rutina AM (10 min) paso a paso'
  }, {
    icon: Moon,
    text: 'Rutina PM (10 min) paso a paso'
  }, {
    icon: CheckSquare,
    text: 'Checklist de entorno (luz, temperatura)'
  }, {
    icon: Utensils,
    text: 'Guía de alimentación sin dogmas'
  }, {
    icon: Activity,
    text: 'Movimiento mínimo efectivo'
  }, {
    icon: Wind,
    text: 'Técnicas de respiración “apagafuego”'
  }, {
    icon: Pill,
    text: 'Guía segura sobre suplementos'
  }, {
    icon: Calendar,
    text: 'Plan completo de 21 días',
    highlight: true
  }];
  return <Section className="bg-white" data-id="element-135">
      <h2 className="text-3xl md:text-4xl font-serif text-center mb-12 text-brand-text" data-id="element-136">
        Qué incluye exactamente
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-137">
        {features.map((feature, i) => <div key={i} className={`flex items-start gap-4 p-5 rounded-xl border transition-all ${feature.highlight ? 'bg-brand-light border-brand-primary/30 shadow-md' : 'bg-white border-gray-100 hover:border-brand-primary/20'}`} data-id="element-138">
            <div className={`p-2 rounded-lg ${feature.highlight ? 'bg-brand-primary text-white' : 'bg-brand-bg text-brand-primary'}`} data-id="element-139">
              <feature.icon className="w-5 h-5" data-id="element-140" />
            </div>
            <div data-id="element-141">
              <p className={`font-medium ${feature.highlight ? 'text-brand-text' : 'text-gray-700'}`} data-id="element-142">
                {feature.text}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}